'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasOwnProperty2 = require('./_internal/_hasOwnProperty');

var _hasOwnProperty3 = _interopRequireDefault(_hasOwnProperty2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var has = (0, _define2.default)(_hasOwnProperty3.default, _INT_TWO2.default); /**
                                                                               * Return true if object has key
                                                                               *
                                                                               * @module has
                                                                               * @func
                                                                               * @since 1.9.0
                                                                               * @param {Object} obj
                                                                               * @param {string} key
                                                                               * @return {function|boolean}
                                                                               * @example
                                                                               *
                                                                               *    has({ a: 1 }, 'a'); //=> true
                                                                               *    has({ a: 1 })('a'); //=> true
                                                                               *    has({ a: 1 })('b'); //=> false
                                                                               */

exports.default = has;